import { ref } from 'vue'
import { defineStore } from 'pinia'
import deepClone from 'www/vue_components/common/TheFilters/lpu/functions/deepClone'
import type {
  Url,
  Town,
  DomNodes,
  LpuList,
} from 'www/vue_components/common/TheFilters/lpu/stores/useCommonStore.types'

const useCommonStore = defineStore('commonStore', () => {
  const url = ref<Url>({
    map: '',
    lpuList: '',
  })
  const town = ref<Town>({
    id: 0,
    name: '',
    translit: '',
    regionalCenter: {
      id: 0,
      name: '',
      translit: '',
    },
  })
  const townReferrer = ref<Town>()
  const domNodes = ref<DomNodes>({
    list: '',
    head: '',
    lpuAd: '',
    container: '',
    headTitle: '',
    pagination: '',
    breadcrumbs: '',
    description: '',
    scrollTarget: '',
    lpuListInfo: '',
    cardsContainer: '',
  })
  const lpuList = ref<LpuList>({
    hasMetro: false,
  })

  const updateUrl = (newUrl: Partial<Url>) => {
    url.value = { ...url.value, ...newUrl }
  }

  const updateTown = (newTown: Partial<Town>) => {
    town.value = { ...town.value, ...newTown }
  }

  /**
   * Заменяем выбранный город на региональный центр и сохраняем исходный город,
   * чтобы можно было восстановить его при сбросе фильтров.
   * Пример: при фильтрации по метро из "Старой Купавны" произойдёт перенаправление на "Москву".
   */
  const updateTownToRegionalCenter = () => {
    townReferrer.value = deepClone(town.value)
    town.value = { ...town.value, ...town.value.regionalCenter }
  }

  /**
   * Если фильтр метро сброшен — восстанавливаем город, который был до перехода на региональный центр.
   */
  const updateTownToReferrer = () => {
    if (townReferrer.value) {
      town.value = townReferrer.value
      townReferrer.value = undefined
    }
  }

  const updateDomNodes = (newDomNodes: Partial<DomNodes>) => {
    domNodes.value = { ...domNodes.value, ...newDomNodes }
  }

  const updateLpuList = (newLpuList: Partial<LpuList>) => {
    lpuList.value = { ...lpuList.value, ...newLpuList }
  }

  return {
    url,
    town,
    domNodes,
    lpuList,
    updateUrl,
    updateTown,
    updateTownToRegionalCenter,
    updateTownToReferrer,
    updateDomNodes,
    updateLpuList,
  }
})

export default useCommonStore
